<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="ASP排产池实时监测r_9"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')} 合计 ${totalArea} (${totalCard}张)`"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="right_9" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import { schedulingPool} from "@/api/cockpit/jyl";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
import {formatTime} from "@/utils";
export default {
  mixins: [resize],
  name: "right_9",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      chartData: [],
      totalArea:0,
      totalCard:0,
      date: new Date()
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
    this.getData();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    getData() {
      this.chartData = []
      schedulingPool().then((resp) => {
        console.log(resp.data);
        for(let item in resp.data){
          if(item != 'total'){
            this.chartData.push({
              value: resp.data[item].total_cutting_area,
              name: resp.data[item].desc,
              num: resp.data[item].total_card,
            })
          }else{
            this.totalArea = resp.data[item].cutting_area;
            this.totalCard = resp.data[item].card;
          }
        }
        console.log(this.total);
        this.initChart();

      });
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("right_9"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            let str =
              "ASP排产池实时监测 <br/>" +
              "<span style='display:inline-block;width:10px;height:10px;border-radius:10px;background-color:" +
              params.color +
              ";'></span>" +
              "\t" +
              params.data.name +
              " : " +
              params.data.value +
              "（" +
              params.data.num +
              "张）";
            return str;
          },
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom: "2%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        color: [
          "#1158a7",
          "#4682B4",
          "#0983ff",
          "#59abf6",
          "#abd6fc",
          "#29beb9",
          "#3bffd0",
          "#22e4ff",
          "#40E0D0",
          "#AFEEEE",
        ],
        series: [
          {
            name: "ASP排产池实时监测",
            type: "pie",
            radius: "50%",
            left: "6%",
            top: "-8%",
            data: this.chartData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: function (params) {
                let str =
                  params.data.name +
                  " : \n" +
                  params.data.value +
                  "（" +
                  params.data.num +
                  "张）";
                return str;
              },
              color: "#C0C4CC",
            },
            labelLine: {
              length: 5,
            },
          },
        ],
      });
    },
    //前一月
    leftClick() {
      //this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      //this.getData();
    },
    //后一月
    rightClick() {
      //this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      //this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 36vh;
  #right_9 {
    height: 100%;
  }
}
</style>
